/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Architect_Detail9Inputs */

const en_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice stack, prompts, booking rules and CRM wiring.`)
};

const ar_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`البنية الصوتية والبرومتات وقواعد الحجز وربط CRM.`)
};

const bn_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ভয়েস স্ট্যাক, প্রম্পট, বুকিং নিয়ম আর CRM সংযোগ।`)
};

const de_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice-Stack, Prompts, Buchungsregeln und CRM-Anbindung.`)
};

const es_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack de voz, prompts, reglas de reserva e integración con el CRM.`)
};

const fr_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack vocale, prompts, règles de réservation et branchement CRM.`)
};

const pt_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stack de voz, prompts, regras de agendamento e ligação ao CRM.`)
};

const zh_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`语音技术栈、提示词、预订规则和 CRM 对接。`)
};

const tr_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ses altyapısı, istemler, rezervasyon kuralları ve CRM bağlantısı.`)
};

const ru_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Голосовой стек, промпты, правила записи и интеграция с CRM.`)
};

const pl_svc_ai_voice_agents_architect_detail9 = /** @type {(inputs: Svc_Ai_Voice_Agents_Architect_Detail9Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voice stack, prompty, reguły rezerwacji i integracja z CRM.`)
};

/**
* | output |
* | --- |
* | "Voice stack, prompts, booking rules and CRM wiring." |
*
* @param {Svc_Ai_Voice_Agents_Architect_Detail9Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_architect_detail9 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Architect_Detail9Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Architect_Detail9Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_architect_detail9(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_architect_detail9(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_architect_detail9(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_architect_detail9(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_architect_detail9(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_architect_detail9(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_architect_detail9(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_architect_detail9(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_architect_detail9(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_architect_detail9(inputs)
	return en_svc_ai_voice_agents_architect_detail9(inputs)
});
export { svc_ai_voice_agents_architect_detail9 as "svc_ai-voice-agents_ARCHITECT_detail" }